import { render } from "./ActivityApproval.vue?vue&type=template&id=4c477ba8&scoped=true"
import script from "./ActivityApproval.vue?vue&type=script&lang=js"
export * from "./ActivityApproval.vue?vue&type=script&lang=js"

import "./ActivityApproval.vue?vue&type=style&index=0&id=4c477ba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c477ba8"]])

export default __exports__